module.exports = __webpack_public_path__ + "img/lefroidvendeen.be3c2f2d.png";